export default __webpack_public_path__ + "static/media/icon-caret-left.1c802e2f.svg";